import { lazy } from 'react';

const VettingProgressPage = lazy(() => import('./pages/VettingProgressPage'));

export const VettingProgressEntry = () => <VettingProgressPage />;
